import { render, staticRenderFns } from "./X-nav.vue?vue&type=template&id=2753d162&scoped=true"
import script from "./X-nav.vue?vue&type=script&lang=js"
export * from "./X-nav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2753d162",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitnami/deploy/oscar_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2753d162')) {
      api.createRecord('2753d162', component.options)
    } else {
      api.reload('2753d162', component.options)
    }
    module.hot.accept("./X-nav.vue?vue&type=template&id=2753d162&scoped=true", function () {
      api.rerender('2753d162', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/nav/X-nav.vue"
export default component.exports